export const loginMessage = 'Log in to fem-fast'
export const apiUrl = process.env.REACT_APP_BACKEND_API
export const loginType = 'email'

export const loginOperationId = (type) => {
  let operationId = 'createSessionByEmail'

  if (type === 'wallet') {
    operationId = 'createSessionByWallet'
  }

  if (type === '2fa') {
    operationId = 'createSessionByAttemptToken'
  }

  return operationId
}

export const USER_TYPE_OPTIONS = [
  { id: 'regular_cycle', name: 'regular_cycle' },
  { id: 'perimenopause', name: 'perimenopause' },
  { id: 'menopause', name: 'menopause' },
  { id: 'postpartum', name: 'postpartum' },
  { id: 'PCOS', name: 'PCOS' },
  { id: 'endometriosis', name: 'endometriosis' },
  { id: 'irregular_cycle', name: 'irregular_cycle' },
  { id: 'pregnant', name: 'pregnant' },
  { id: 'hormonal_birth_control', name: 'hormonal_birth_control' },
  { id: 'without_cycle', name: 'without_cycle' },
]

export const PHASE_TYPE_OPTIONS = [
  { id: 'menstrual', name: 'menstrual' },
  { id: 'follicular', name: 'follicular' },
  { id: 'ovulation', name: 'ovulation' },
  { id: 'luteal', name: 'luteal' },
  { id: 'general', name: 'general' },
]

export const MODAL_TYPE_OPTIONS = [
  { id: 'allTasksDone', name: 'allTasksDone' },
  { id: 'periodTrackedNearToday', name: 'periodTrackedNearToday' },
  { id: 'recommendationDaily', name: 'recommendationDaily' },
  { id: 'recommendationWeekly', name: 'recommendationWeekly' },
  { id: 'phaseChangedToMenstrual', name: 'phaseChangedToMenstrual' },
  { id: 'phaseChangedToFollicular', name: 'phaseChangedToFollicular' },
  { id: 'phaseChangedToOvulation', name: 'phaseChangedToOvulation' },
  { id: 'phaseChangedToLuteal', name: 'phaseChangedToLuteal' },
  { id: 'daysInApp1', name: 'daysInApp1' },
  { id: 'daysInApp2', name: 'daysInApp2' },
  { id: 'daysInApp3', name: 'daysInApp3' },
  { id: 'daysInApp5', name: 'daysInApp5' },
  { id: 'daysInApp7', name: 'daysInApp7' },
  { id: 'daysInApp9', name: 'daysInApp9' },
  { id: 'daysInApp12', name: 'daysInApp12' },
  { id: 'daysInApp14', name: 'daysInApp14' },
  { id: 'daysInApp21', name: 'daysInApp21' },
  { id: 'daysInApp30', name: 'daysInApp30' },
]

export const GOAL_OPTIONS = [
  { id: 'weight_loss_and_fat_reduction', name: 'weight_loss_and_fat_reduction' },
  {
    id: 'energy_stabilization_and_fatigue_reduction',
    name: 'energy_stabilization_and_fatigue_reduction',
  },
  {
    id: 'balance_my_hormones_and_stabilize_my_cycle',
    name: 'balance_my_hormones_and_stabilize_my_cycle',
  },
  {
    id: 'optimize_workouts_and_build_muscle',
    name: 'optimize_workouts_and_build_muscle',
  },
  { id: 'reduce_PMS_symptoms', name: 'reduce_PMS_symptoms' },
  { id: 'ease_menopause_symptoms', name: 'ease_menopause_symptoms' },
  {
    id: 'support_overall_health_and_longevity',
    name: 'support_overall_health_and_longevity',
  },
  {
    id: 'recover_after_pregnancy_and_regain_energy',
    name: 'recover_after_pregnancy_and_regain_energy',
  },
]

export const RECCOMENDATION_TYPE_OPTIONS = [
  { id: 'fasting', name: 'fasting' },
  { id: 'nutrition', name: 'nutrition' },
  { id: 'workout', name: 'workout' },
  { id: 'supplements', name: 'supplements' },
  { id: 'general', name: 'general' },
  { id: 'shoppingList', name: 'shopping list' },
]

export const ARTICLE_TYPE_OPTIONS = [
  { id: 'dashboard', name: 'dashboard' },
  { id: 'fasting', name: 'fasting' },
  { id: 'cycle', name: 'cycle' },
]
